<div class="form-horizontal">
    <div class="row">
        <div class="col-md-12">
            <div class="btn-group-ticomix">
                <button type="button" class="btn btn-ticomix" (click)="saveAttachment()">
                    <span class="fa fa-save"></span> Save
                </button>
                <button type="button" class="btn btn-ticomix" (click)="closeAttachment()">
                    <span class="fa fa-ban"></span> Cancel
                </button>
                <button *ngIf="canDeleteAttachment" type="button" class="btn btn-ticomix"
                    (click)="deleteAttachment()">
                    <span class="fa fa-trash-alt"></span> Delete
                </button>
            </div>
        </div>
    </div>
</div>
<div class="p-3">
    <div class="mb-3">
        <label for="description" class="form-label">Description</label>
        <input id="description" type="text" class="form-control" [(ngModel)]="description"
            name="description" />
    </div>
</div>